import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10efa770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cargos por Manejo")
], -1))
const _hoisted_8 = { class: "card overflow-scroll" }
const _hoisted_9 = { class: "table table-hover table-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripción"),
    /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tarifas Por Cargos")
], -1))
const _hoisted_22 = { class: "card overflow-scroll" }
const _hoisted_23 = { class: "table table-hover table-sm" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Inicio"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Final"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor"),
    /*#__PURE__*/_createElementVNode("th", null, "Aplica"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_25 = { class: "btn-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_31 = [
  _hoisted_30
]

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Cargcaman, Cartarman } from '@/interface/interfaces';
import { stringifyQuery } from 'vue-router';
import { UrlGlobal } from '@/store/dominioGlobal';
import InCargCaman from './pInsert/InCargCaman.vue';
import UpCargCaman from './pUpdate/UpCargCaman.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CarTarMan',
  setup(__props) {

const dUrl = UrlGlobal()
const cargoRef = ref<string | null >(null)

//-----------------------------------------------------------------
const cargcaman = ref<Array<Cargcaman>>([]);
const getCargos = () => {
    axios.get(`${dUrl.urlGlobal}/api2/cargcaman`)
        .then(response => {
            cargcaman.value = response.data;

            //console.log(cargcaman.value[0].naturaleza)
        })
        .catch(error => {
            console.error('Error al Accesar los Cargos:', error);
        });
};
//----------------------------------------------------------------
const cartarman = ref<Array<Cartarman>>([])

const getVigencias = (id_tarifa: any, id_cargo: any, id_nombre: any, id_tipo: any, id_status: any) => {
    cargoRef.value = id_cargo
    axios.get(`${dUrl.urlGlobal}/api2/cargcaman/cartarman?id_tarifa=${id_tarifa}&id_cargo=${id_cargo}`)
        .then(response => {
            cartarman.value = response.data;

        if (clickUp.value) {
            console.log(id_cargo)
            console.log(id_nombre)
            FunClick(id_cargo, id_nombre, id_tipo, id_status)
        }
        })
        .catch(error => {
            console.error('Error al cargar los Cargos:', error);
        });
};
//funcion de los botones y las extenciones de Insert,delete,update----------------
let cargo : any
let nombre : any
let tipo : any
let status: any

let btnUp = ref(false);//variable para mostrar modal de update
let clickUp = ref(false)//variable para activar el click de Up
let btnIn = ref(false);//variable modal insert
let btnDl = ref(false);//variable para mostrar modal del delete
let clickDl = ref(false);//variable para activar el click del delete

let btnTaUp = ref(false);
let clickTaUp = ref(false);
let btnTaIn = ref(false);
let btnTaDl = ref(false);
let clickTaDl = ref(false);

//funciones q activan el click y en el caso del insert muestran el modal
const CbtnUp = () => {
  clickUp.value = !clickUp.value
  clickDl.value = false
}
const CbtnIn = () => {
  btnIn.value = !btnIn.value
  clickUp.value = false
  clickDl.value = false
}

const CbtnDl = () => {
  clickDl.value = !clickDl.value
  clickUp.value = false
}

const CbtnTaIn = () => {
  btnTaIn.value = !btnTaIn.value
  clickTaUp.value = false
  clickTaDl.value = false
}
const CbtnTaUp = () => {
  clickTaUp.value = !clickTaUp.value
  clickTaDl.value = false
}

const CbtnTaDl = () => {
  clickTaDl.value = !clickTaDl.value
  clickTaUp.value = false
}
//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const FunClick = (al: any, ar: any, an: any, st: any) => {
  let cargo = al;
  let nombre = ar;
  let tipo = an;
  let status = st;

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  }
  if (clickDl.value == true) {
    btnDl.value = !btnDl.value
    clickDl.value = !clickDl.value
  }

  if (clickTaUp.value == true) {
    btnTaUp.value = !btnTaUp.value
    clickTaUp.value = !clickTaUp.value
  }

  if (clickTaDl.value == true) {
    btnTaDl.value = !btnTaDl.value
    clickTaDl.value = !clickTaDl.value
  }
}
//funciones de emits para actualizar las variables y cierre los modales activos sea de update o insert
function 
updatePropsValue(newValue: boolean, cargo: any) {
  btnUp.value = newValue
  cargo.value = String
   
  getCargos() 
  getVigencias('02', cargo.value, '', '', '')
}

function insertPropsValue(newValue: boolean) {
  btnIn.value = newValue
  getCargos();   
  getVigencias('02', '', '', '', '')
}
//---- Tarifas
function updTaPropsValue(newValue: boolean, tarifa: any, fecha: any,cargo: any, status: any) {
  btnTaUp.value = newValue
  tarifa.value = tarifa
  fecha.value = fecha
  cargo.value = cargo
  status.value = status

  getCargos()  
  getVigencias('', '', '', '', '')
}

function insTaPropsValue(newValue: boolean, tarifa: any, fecha: any, cargo: any ) {
  btnTaIn.value = newValue
  tarifa.value = tarifa
  fecha.value = fecha
  cargo.value = cargo

  getCargos();   
  getVigencias('', '', '', '', '')
}
//----------------------------------------------------------------

onMounted(() => {
    getCargos();
    getVigencias("02", "01", '', '', '')
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cargcaman.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.cargo,
                        onClick: ($event: any) => (getVigencias('02', elm.cargo, elm.nombre, elm.tipo, elm.status)),
                        class: _normalizeClass({ 'table-primary': elm.cargo === cargoRef.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_tipo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 10, _hoisted_11))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn-insert",
              onClick: _withModifiers(CbtnIn, ["prevent"])
            }, _hoisted_14),
            _createElementVNode("button", {
              class: "btn-update",
              onClick: _withModifiers(CbtnUp, ["prevent"])
            }, _hoisted_16),
            _createElementVNode("button", {
              class: "btn-delete",
              onClick: _withModifiers(CbtnDl, ["prevent"])
            }, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartarman.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.cargo
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_inicio), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_final), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.valor), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_aplica), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "btn-insert",
              onClick: _withModifiers(CbtnIn, ["prevent"])
            }, _hoisted_27),
            _createElementVNode("button", {
              class: "btn-update",
              onClick: _withModifiers(CbtnUp, ["prevent"])
            }, _hoisted_29),
            _createElementVNode("button", {
              class: "btn-delete",
              onClick: _withModifiers(CbtnDl, ["prevent"])
            }, _hoisted_31)
          ])
        ]),
        (_unref(btnUp))
          ? (_openBlock(), _createBlock(UpCargCaman, {
              key: 0,
              cargo: _unref(cargo),
              nombre: _unref(nombre),
              tipo: _unref(tipo),
              status: _unref(status),
              btnUp: _unref(btnUp),
              onUpdateProps: updatePropsValue
            }, null, 8, ["cargo", "nombre", "tipo", "status", "btnUp"]))
          : _createCommentVNode("", true),
        (_unref(btnIn))
          ? (_openBlock(), _createBlock(InCargCaman, {
              key: 1,
              btnIn: _unref(btnIn),
              onInsertProps: insertPropsValue
            }, null, 8, ["btnIn"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})